import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toString',
})
export class ToStringPipe implements PipeTransform {
  transform(value: any): string {
    if (value === null || value === undefined) return '';
    return value + '';
  }
}
